import { TaxaArredondamento, TaxaEntregaConfig, TaxaTipo, taxaEntregaConfigPadrao } from './taxa-entrega';

// Retorno de `aps://integracao/panorama/taxaentrega/{empresaId}/{estabelecimentoId}`:
//   { "codigo": "1010", "nome": "Taxa de Entrega",
//     "itemEntregas": [ { "de": 0, "ate": 1, "valor": 10 }, { "de": 1, "ate": 5, "valor": 20 } ] }
export type TaxaEntregaPanoramaFaixa = {
  de: number;
  ate: number;
  valor: number;
};

export type TaxaEntregaPanorama = {
  codigo: string;
  nome: string;
  itemEntregas: TaxaEntregaPanoramaFaixa[];
};

// O motor usa faixa de fim implicito (`ateKm`), entao o `de` e descartado. Lacuna entre
// faixas fecha para cima, herdando o valor da faixa seguinte - nunca inventando valor.
export function taxaEntregaPanoramaFaixas(panorama: TaxaEntregaPanorama): { ateKm: number; valor: number }[] {
  return (panorama?.itemEntregas || [])
    .filter(faixa => faixa && Number.isFinite(faixa.ate) && Number.isFinite(faixa.valor))
    .slice()
    .sort((a, b) => a.ate - b.ate)
    .map(faixa => ({ ateKm: faixa.ate, valor: faixa.valor }));
}

// Alem do maior `ate` o endereco esta fora de area.
export function taxaEntregaPanoramaAlcance(panorama: TaxaEntregaPanorama): number {
  const faixas = taxaEntregaPanoramaFaixas(panorama);
  return faixas.length ? faixas[faixas.length - 1].ateKm : 0;
}

export function taxaEntregaPanoramaValido(panorama: TaxaEntregaPanorama): boolean {
  return taxaEntregaPanoramaFaixas(panorama).length > 0;
}

// A origem nao vem no endpoint, por isso `origemAtual` entra por parametro.
export function taxaEntregaPanoramaConverte(
  panorama: TaxaEntregaPanorama,
  origemAtual?: TaxaEntregaConfig,
): TaxaEntregaConfig {
  const base = origemAtual || taxaEntregaConfigPadrao();
  return {
    ...base,
    tipo: TaxaTipo.Dinamica,
    modoFaixa: true,
    faixasDinamica: taxaEntregaPanoramaFaixas(panorama),
    kmMaximo: taxaEntregaPanoramaAlcance(panorama),
    arredondamento: TaxaArredondamento.PorKm,
    // Zerado para sobra de config local antiga nao descontar frete que o backend nao mandou.
    freteGratisAcimaDe: 0.00,
    entregaGratis: false,
    picoAtivo: false,
  };
}
